//Footer
import React from "react";
import styles from "./footer.module.css";
import { Link } from "react-router-dom";
import instagram from "../../images/instagram.svg";
import facebook from "../../images/facebook.svg";
import twitter from "../../images/twitter.svg";
import linkedin from "../../images/linkedin.svg";
import edu from "../../images/EduUdr.svg";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import location from "../../images/location.svg";
import phone from "../../images/phone.svg";
import message from "../../images/message.svg";
import feedback from "../../images/feedback.svg";
import lightcom from "../../images/lightcomindia.png";
import lightenergy from "../../images/lighteneryindia.png";
import paisaback from "../../images/paisaback.png";
import udrcrafts from "../../images/udrcrafts.png";
import udrlight from "../../images/udrlight.png";
import udrai from "../../images/UdrAI.png";
import crafts from "../../images/crafts.png";
import Logo from "../Logo/Logo";

const Footer = () => {
  const FooterCompone = () => {
    return (
      <div>
        {/* <div className={styles.sponsors}>
          <h2 className={styles.heading}>Sponsored by</h2>
          <div className={styles.sponsorgrid}>
            <div>
              <a href="http://UdrLight.com" target="_blank" rel="noreferrer">
                <img alt="" src={udrlight} />
              </a>
            </div>
            <div>
              <a
                href="https://LightEnergyIndia.com"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="" src={lightenergy} />
              </a>
            </div>
            <div>
              <a
                href="http://Udrarchitect.com"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="" src={udrcrafts} />
              </a>
            </div>
            <div>
              <a href="http://udrcrafts.com" target="_blank" rel="noreferrer">
                <img alt="" src={crafts} />
              </a>
            </div>
            <div>
              <a href="http://udrai.com" target="_blank" rel="noreferrer">
                <img alt="" src={udrai} />
              </a>
            </div>

            <div>
              <a
                href="http://lightcomindia.com"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="" src={lightcom} />
              </a>
            </div>

            <div>
              <a
                href="https://www.paiseback.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="" src={paisaback} />
              </a>
            </div>
          </div>
        </div> */}
        <footer>
          <div className={styles.footer}>
            <div className={styles.logo}>
              <Logo />
              <span className={styles.head}>upgrading the community</span>
              <span className={styles.head}>
                Join as a learner or a creator <br /> and grow with us.
              </span>
            </div>
            <div>
              <div className={styles.head}>
                <span>Contact Us</span>
              </div>
              <div className={`${styles.middle} ${styles.contact}`}>
                <a href="mailto:contact@eduudr.org">
                  <p className={styles.location}>
                    <img src={message} alt="location" />
                    contact@eduudr.org
                  </p>
                </a>
                <a
                  href="https://wa.me/918118846888"
                  target={"blank"}
                  rel="noreferrer"
                >
                  <p className={styles.location}>
                    <img src={phone} alt="location" />
                    +918118846888
                  </p>
                </a>
                <a
                  href="https://bit.ly/EduUdr_Feedback"
                  rel="noreferrer"
                  target="_blank"
                >
                  <p className={styles.location}>
                    <img src={feedback} alt="location" />
                    Give a Feedback
                  </p>
                </a>

                {/* <a
                  href="https://www.google.com/maps/place/EduUdr+India/@24.6241206,73.7083133,17z/data=!3m1!4b1!4m5!3m4!1s0x3967e596de0b8b71:0x44b88e903187888b!8m2!3d24.6241033!4d73.710558"
                  rel="noreferrer"
                  target="_blank"
                >
                  <p className={styles.location}>
                    <img src={location} alt="location" />
                    EduUdr India, Moti Mahal, Sukher, Rajasthan 313001
                  </p>
                </a> */}
              </div>
            </div>
            {/* <div>
            <div className={styles.head}>
              <span>MORE</span>
            </div>

            <div className={styles.middle}>
              <p>About</p>
              <p>Terms & Conditions</p>
            </div>
            <br />
            <div className={styles.terms}></div>
          </div> */}
            <div>
              <div className={styles.head}>
                <span>Follow Us On</span>
              </div>
              <div className={`${styles.middle}`}>
                <div
                  className={`${styles.imgContainer} flex justify-center items-center`}
                >
                  <a
                    rel="noreferrer"
                    href="https://www.instagram.com/eduudr"
                    target="_blank"
                  >
                    <img src={instagram} alt="" className={styles.social} />
                  </a>
                  <a
                    rel="noreferrer"
                    href="https://t.me/EduUdr"
                    target="_blank"
                  >
                    <img src={twitter} alt="" className={styles.socials} />
                  </a>
                  <a
                    rel="noreferrer"
                    href="https://www.linkedin.com/company/eduudr"
                    target="_blank"
                  >
                    {" "}
                    <img src={linkedin} alt="" className={styles.socials} />
                  </a>
                  <a
                    rel="noreferrer"
                    href="https://www.youtube.com/c/EduUdr"
                    target="_blank"
                  >
                    <img src={facebook} alt="" className={styles.socials} />
                  </a>
                </div>
              </div>
              <div className={styles.bottommostright}>
                <a href="/termsandconditions" style={{ padding: "10px 0" }}>
                  Terms & Conditions
                </a>
                <span style={{ marginTop: "25px" }}>All Rights Reserved </span>
                <span>UdrLight©2020-{new Date().getFullYear()}</span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  };

  return <>{FooterCompone()}</>;
};

export default Footer;
